export function AppTableShell({ children }: { children: React.ReactNode }) {
  return <div className="app-table-shell -mx-4 px-4">{children}</div>;
}
